export const HELP_NOTE_UPDATE = 'ASSISTANT_HELP_NOTE_UPDATE';
export const OPTIONS_UPDATE = 'ASSISTANT_OPTIONS_UPDATE';
export const RESET_OPTIONS = 'ASSISTANT_RESET_OPTIONS';
export const RATING_ADDL_UPDATE = 'ASSISTANT_RATING_ADDL_UPDATE';

export const updateHelpNote = (helpNote) => ({
  type: HELP_NOTE_UPDATE,
  payload: helpNote
});

export const updateRedesignOptions = (options) => ({
  type: OPTIONS_UPDATE,
  payload: options
});

export const resetRedesignOptions = () => ({
  type: RESET_OPTIONS
});

export const updateRedesignRatingAddlFeedback = (addlFeedback) => ({
  type: RATING_ADDL_UPDATE,
  payload: addlFeedback
});
